import { cookieManager } from "@/_old/utils/cookie-manager";
import { apiGateway } from "@/_old/services/api-gateway";
import { useCallback } from "react";
import { useFeatureFlags } from "@/_old/hooks/use-feature-flag";
import { removeAllTokens } from "../services/cookies";
import { clearAllChatData } from "@/core/utils/chatbot-storage";

export function useLogout() {
  const { isDemo } = useFeatureFlags();

  const signOut = useCallback(() => {
    if (isDemo) return;

    removeAllTokens();

    cookieManager.remove({ cookieName: "u_id", globally: true });
    cookieManager.remove({ cookieName: "u_hs", globally: true });
    cookieManager.remove({ cookieName: "u_p", globally: true });

    // Limpar estado do chat da Lia (localStorage e sessionStorage)
    clearAllChatData();

    apiGateway.post("auth/logout");
    window.location.href = import.meta.env.VITE_PORTAL_URL;
  }, [isDemo]);

  return { signOut };
}
